function getLanguage(page) {
  return page?.language() || "de";
}

export default getLanguage;
